import React, {useEffect} from 'react';
import heroPlus from '../../assets/hero-plus.png';
import heroImage from '../../assets/hero.png';
import * as S from './HeroSuperPower.styles';

const TickWhiteIcon = () => (
  <span className="sprite ic_tickWhite">
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.2"
        d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z"
        fill="#C97907"
      />
      <path
        d="M22.6335 12.4883L13.7879 21.0736L9.36523 16.781"
        stroke="#5E0202"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </span>
);

const HeroSuperPower = ({data}) => {
  const {hero, heroStar, heroSuperStar} = data || {};

  if (typeof window === 'undefined') {
    return null;
  }

  const renderList = ({listData, classUl}) => {
    return (
      <ul className={`${classUl}`}>
        {listData?.length
          ? listData.map(
              (
                {
                  order,
                  boldText,
                  normalText,
                  highlight,
                  icon = 'sprite ic_tick',
                  isBrownTick = false,
                },
                index,
              ) => {
                return order?.length ? (
                  <li
                    className={highlight ? 'highlightText inline-text' : 'inline-text'}
                    key={index}
                  >
                    {isBrownTick ? <TickWhiteIcon /> : <span className={`${icon}`} />}
                    <p>
                      {order.map((item, key) => {
                        switch (item) {
                          case 'normalText':
                            return <span key={key}>{normalText} </span>; // Wrap normal text in span
                          case 'boldText':
                            return <strong key={key}>{boldText} </strong>; // Wrap bold text in strong
                          default:
                            return null;
                        }
                      })}
                    </p>
                  </li>
                ) : null;
              },
            )
          : null}
      </ul>
    );
  };

  return (
    <S.Container>
      <h3>
        What are myPartner <span>HERO Benefits?</span>
      </h3>
      <S.ContainerInner>
        <S.Hero>
          <img src={heroImage} alt="hero" />
          <h4>HERO</h4>
          <h5>
            Make completed travel bookings worth <span>₹7 Lakhs</span> in a month to get:
          </h5>
          {hero?.listData?.length
            ? renderList({listData: hero?.listData, classUl: 'ulHero'})
            : null}
        </S.Hero>
        <S.Hero>
          {/*<S.HeroPlusNewTag>NEW</S.HeroPlusNewTag>*/}
          <img
            src={'https://assets-gos3.goibibo.com/myp_HeroStar-1679992575.svg'}
            alt="hero plus"
          />
          <h4>HERO Star</h4>
          <h5>
            Make completed travel bookings worth <span>₹15 Lakhs</span> (<span>₹6.5 Lakhs</span> on
            Hotels) in a month to get:
          </h5>
          {heroStar?.listData?.length
            ? renderList({listData: heroStar?.listData, classUl: ''})
            : null}
        </S.Hero>
        <S.HeroPlus>
          <img
            src={'https://assets-gos3.goibibo.com/myp_heroSuperStar-1680088136.png'}
            alt="hero plus"
          />
          <h4>HERO Superstar</h4>
          <h5>
            Make completed travel bookings worth <span>₹25 Lakhs</span> (<span>₹11 Lakhs</span> on
            Hotels) in a month to get:
          </h5>
          {heroSuperStar?.listData?.length
            ? renderList({listData: heroSuperStar?.listData, classUl: ''})
            : null}
        </S.HeroPlus>
      </S.ContainerInner>
    </S.Container>
  );
};

export default HeroSuperPower;
